import React from 'react'
import blogsBanner from '../assets/bannerImages/blogsBanner.webp'
// import monitoringTheDeviation from '../assets/images/monitoringTheDeviation.webp'
// import './Blogs.css'
import { Link } from 'react-router-dom'

export default function Blogs(){
    return(
        <div className="blogs">
            <BR1/>
            <BR2/>
        </div>
    )
}

function BR1(){
    return(
        <div className='br1'>
            <h1>Blogs</h1>
        </div>
    )
}
function BR2(){
    return(
        <div className='br2'>
            <Block img={blogsBanner} title='Coming Soon' className='blogItem' link='/blog-post' />
            <Block img={blogsBanner} title='Coming Soon' className='blogItem' link='/blog-post-two' />
            <Block img={blogsBanner} title='Coming Soon' className='blogItem' link='/blog-post-three' />
        </div>
    )
}

function Block(props){
    return(
        <div className='block'>
            <Link to={props.link} ><img loading="lazy" src={props.img} alt='blog-block-img' className='blockImg'/></Link>
            <Link to={props.link} ><h2 className='title'>{props.title}</h2></Link>
            <Link to={props.link} ><button className='btn'>Read More</button></Link>
        </div>
    )
}